var _symbol, _symbol2, _path, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cancelled",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7c7165",
    style: {
      fill: "var(--color1, #7c7165)"
    },
    d: "M16 32c-8.836 0-16-7.164-16-16s7.164-16 16-16c8.836 0 16 7.164 16 16s-7.164 16-16 16zM8.943 7.057c-0.24-0.232-0.566-0.374-0.926-0.374-0.736 0-1.333 0.597-1.333 1.333 0 0.36 0.143 0.687 0.375 0.927l7.057 7.057-7.057 7.057c-0.251 0.243-0.407 0.583-0.407 0.959 0 0.736 0.597 1.333 1.333 1.333 0.376 0 0.716-0.156 0.959-0.407l7.058-7.058 7.057 7.057c0.24 0.232 0.566 0.374 0.926 0.374 0.736 0 1.333-0.597 1.333-1.333 0-0.36-0.143-0.687-0.375-0.927l-7.057-7.057 7.057-7.057c0.232-0.24 0.374-0.566 0.374-0.926 0-0.736-0.597-1.333-1.333-1.333-0.36 0-0.687 0.143-0.927 0.375l-7.057 7.057-7.057-7.057z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkbox-empty",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M6 6h20v20h-20z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkbox-full",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.878 10.479c0.077-0.138 0.122-0.303 0.122-0.479 0-0.552-0.448-1-1-1-0.377 0-0.705 0.208-0.875 0.516l-0.003 0.005-5.272 9.669-4.563-5.807c-0.184-0.241-0.472-0.395-0.796-0.395-0.552 0-1 0.448-1 1 0 0.24 0.085 0.461 0.226 0.633l-0.001-0.002 5.5 7c0.185 0.233 0.468 0.382 0.786 0.382 0.377 0 0.705-0.209 0.876-0.516l0.003-0.005 6-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5c-0.552 0-1 0.448-1 1v0 20c0 0.552 0.448 1 1 1v0h20c0.552 0 1-0.448 1-1v0-20c0-0.552-0.448-1-1-1v0h-20zM7 25v-18h18v18h-18z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-done",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00aa3a",
    style: {
      fill: "var(--color2, #00aa3a)"
    },
    d: "M32 16c0 8.836-7.164 16-16 16s-16-7.164-16-16 7.164-16 16-16 16 7.164 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffbff",
    style: {
      fill: "var(--color3, #fffbff)"
    },
    d: "M24.319 7.127c0.675 0.368 0.923 1.213 0.555 1.888l-8.347 15.304c-0.241 0.435-0.698 0.725-1.222 0.725-0.443 0-0.837-0.207-1.092-0.529l-0.002-0.003-7.653-9.74c-0.174-0.23-0.279-0.52-0.279-0.836 0-0.769 0.623-1.392 1.392-1.392 0.432 0 0.819 0.197 1.074 0.506l0.002 0.002 6.347 8.080 7.337-13.453c0.368-0.675 1.213-0.923 1.888-0.555z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 32 32"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23 25.308l-2.538-2.539-1.692 4.231 4.23-1.692z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1e1e1e",
    style: {
      stroke: "var(--color4, #1e1e1e)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M6.692 22.77l17.77-17.77 2.538 2.538-17.77 17.77M6.692 22.769l2.539 2.539M6.692 22.769l-1.692 4.231 4.23-1.692"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-closed",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7c7165",
    style: {
      fill: "var(--color1, #7c7165)"
    },
    d: "M7.672 6.293c-0.18-0.174-0.425-0.281-0.695-0.281-0.552 0-1 0.448-1 1 0 0.27 0.107 0.515 0.281 0.695l2.827 2.827c-0.598 0.294-1.16 0.626-1.678 0.992-1.645 1.161-2.897 2.699-3.442 4.474 0.546 1.775 1.797 3.313 3.442 4.474 2.24 1.58 5.28 2.526 8.592 2.526 1.71 0 3.347-0.252 4.839-0.713l3.42 3.42c0.18 0.174 0.425 0.281 0.695 0.281 0.552 0 1-0.448 1-1 0-0.27-0.107-0.515-0.281-0.695l-2.805-2.805c0.616-0.3 1.193-0.639 1.725-1.014 1.645-1.161 2.896-2.699 3.442-4.474-0.546-1.775-1.797-3.313-3.442-4.474-2.24-1.58-5.28-2.526-8.593-2.526-1.73 0-3.385 0.258-4.89 0.73l-3.438-3.438zM10.594 12.043c-0.748 0.315-1.43 0.692-2.034 1.117-1.157 0.816-1.992 1.79-2.46 2.84 0.468 1.050 1.303 2.023 2.46 2.84 1.864 1.315 4.49 2.16 7.44 2.16 1.122 0 2.198-0.123 3.204-0.347l-8.61-8.61zM21.356 19.977l-8.617-8.617c0.972-0.229 2.088-0.36 3.235-0.36 0.009 0 0.018 0 0.027 0h-0.001c2.949 0 5.576 0.845 7.44 2.16 1.156 0.816 1.992 1.79 2.46 2.84-0.468 1.050-1.304 2.023-2.46 2.84-0.617 0.435-1.316 0.818-2.083 1.137z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-open",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7c7165",
    style: {
      fill: "var(--color1, #7c7165)"
    },
    d: "M3.965 16c0.546 1.775 1.797 3.313 3.442 4.474 2.24 1.58 5.28 2.526 8.592 2.526s6.353-0.946 8.593-2.526c1.645-1.161 2.896-2.699 3.442-4.474h-2.135c-0.468 1.050-1.304 2.023-2.46 2.84-1.864 1.315-4.491 2.16-7.44 2.16-2.948 0-5.575-0.845-7.439-2.16-1.157-0.817-1.992-1.79-2.46-2.84h-2.136zM6.1 16c0.468-1.050 1.303-2.024 2.46-2.84 1.864-1.315 4.49-2.16 7.44-2.16 2.948 0 5.575 0.845 7.439 2.16 1.156 0.816 1.992 1.79 2.46 2.84h2.135c-0.546-1.775-1.797-3.313-3.442-4.474-2.24-1.58-5.28-2.526-8.593-2.526s-6.353 0.946-8.592 2.526c-1.645 1.161-2.897 2.699-3.442 4.474h2.134z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c7165",
    style: {
      fill: "var(--color1, #7c7165)"
    },
    d: "M20.018 16c0 2.209-1.791 4-4 4s-4-1.791-4-4v0c0-2.209 1.791-4 4-4s4 1.791 4 4v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004f98",
    style: {
      fill: "var(--color5, #004f98)"
    },
    d: "M5 6c0-0.552 0.448-1 1-1v0h20c0.552 0 1 0.448 1 1v0 20c0 0.552-0.448 1-1 1v0h-20c-0.552 0-1-0.448-1-1v0-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffbff",
    style: {
      fill: "var(--color3, #fffbff)"
    },
    d: "M22.479 9.122c0.313 0.173 0.521 0.501 0.521 0.878 0 0.176-0.045 0.341-0.125 0.484l0.003-0.005-6 11c-0.173 0.313-0.501 0.521-0.878 0.521-0.318 0-0.601-0.148-0.785-0.38l-0.002-0.002-5.5-7c-0.14-0.171-0.224-0.391-0.224-0.631 0-0.552 0.448-1 1-1 0.324 0 0.612 0.154 0.795 0.393l0.002 0.002 4.563 5.807 5.273-9.668c0.173-0.313 0.501-0.521 0.878-0.521 0.176 0 0.341 0.045 0.484 0.125l-0.005-0.003z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter-empty",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fffbff",
    style: {
      fill: "var(--color3, #fffbff)",
      stroke: "var(--color5, #004f98)"
    },
    stroke: "#004f98",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M6 6h20v20h-20z"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 27.476l10.19-11.28c2.413-2.67 2.413-7 0-9.67-2.411-2.67-6.322-2.67-8.734 0l-0.786 0.87c-0.163 0.188-0.403 0.307-0.67 0.307s-0.507-0.118-0.669-0.306l-0.001-0.001-0.786-0.87c-2.412-2.67-6.323-2.67-8.735 0s-2.412 7 0 9.67l10.191 11.279zM24.85 8.010c1.672 1.85 1.672 4.85 0 6.7l-8.85 9.797-8.85-9.796c-1.672-1.85-1.672-4.85 0-6.7s4.382-1.85 6.053 0l2.797 3.095 2.797-3.095c1.671-1.85 4.381-1.85 6.053 0z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-login",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M20.612 9.587c0 2.547-2.065 4.612-4.612 4.612s-4.612-2.065-4.612-4.612v0c0-2.547 2.065-4.612 4.612-4.612s4.612 2.065 4.612 4.612v0zM26.186 23.807c0.426 1.028 0.693 2.113 0.794 3.218h-21.96c0.527-5.645 5.241-10.029 10.979-10.029 4.568 0 8.487 2.779 10.16 6.738l0.027 0.072z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-magnifier",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M23 14c0 4.694-3.806 8.5-8.5 8.5s-8.5-3.806-8.5-8.5c0-4.694 3.806-8.5 8.5-8.5s8.5 3.806 8.5 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M20 20.5l7 7"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pending",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004f98",
    style: {
      fill: "var(--color5, #004f98)"
    },
    d: "M32 16c0 8.836-7.164 16-16 16s-16-7.164-16-16 7.164-16 16-16 16 7.164 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M8.973 12.928c-0.406 0.905-0.643 1.961-0.643 3.073 0 4.235 3.433 7.668 7.668 7.668s7.668-3.433 7.668-7.668c0-3.767-2.716-6.899-6.296-7.546l-0.047-0.007c-0.727-0.128-1.328-0.715-1.327-1.453v-0.331c0.001-0.735 0.6-1.341 1.332-1.261 2.013 0.219 3.613 0.948 5.153 2.127 2.555 1.969 4.184 5.030 4.184 8.471 0 5.891-4.776 10.667-10.667 10.667s-10.667-4.776-10.667-10.667c0-1.598 0.352-3.115 0.982-4.476l-0.027 0.066-1.255 0.359c-0.11 0.033-0.236 0.051-0.367 0.051-0.736 0-1.333-0.597-1.333-1.333 0-0.606 0.404-1.117 0.957-1.28l0.009-0.002 4.667-1.333c0.11-0.033 0.237-0.052 0.367-0.052 0.606 0 1.117 0.404 1.279 0.957l0.002 0.009 1.333 4.667c0.033 0.11 0.051 0.236 0.051 0.367 0 0.736-0.597 1.333-1.333 1.333-0.606 0-1.117-0.404-1.28-0.957l-0.002-0.009-0.412-1.439z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-phone",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M4.603 8.68c0.363-2.537 3.35-3.623 5.025-3.93 0.043-0.010 0.094-0.015 0.145-0.015 0.253 0 0.475 0.136 0.596 0.338l0.002 0.003c0.594 1.010 1.847 3.59 2.818 5.367 0.234 0.429 0.138 0.963-0.225 1.29-1.077 0.971-2.522 2.477-2.36 3.447 0.5 3 5.5 6.5 6.5 6 0.855-0.428 2.17-1.92 3.060-2.673 0.26-0.22 0.624-0.235 0.93-0.082l5.647 2.824c0.482 0.24 0.688 0.819 0.424 1.287-1.042 1.848-3.003 4.3-5.062 4.644-3 0.5-8.184-0.185-12.5-4.5-5.5-5.5-5.5-10.5-5-14z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7c7165",
    style: {
      fill: "var(--color1, #7c7165)"
    },
    d: "M16 6.515c0.552 0 1 0.448 1 1v0 7.485h7.484c0.552 0 1 0.448 1 1s-0.448 1-1 1v0h-7.484v7.485c0 0.552-0.448 1-1 1s-1-0.448-1-1v0-7.485h-7.486c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h7.485v-7.485c0-0.552 0.448-1 1-1 0 0 0.001 0 0.001 0h-0z"
  })), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.449 11.577l-6.389 1.016c-0.474 0.078-0.837 0.49-0.837 0.987 0 0.276 0.112 0.526 0.292 0.707l4.562 4.567c0.181 0.181 0.292 0.431 0.292 0.707 0 0.055-0.004 0.109-0.012 0.156l-1.005 6.37c-0.009 0.053-0.013 0.107-0.013 0.162 0 0.552 0.448 1 1 1 0.166 0 0.322-0.040 0.454-0.109l5.755-2.928c0.135-0.069 0.289-0.107 0.451-0.107 0.165 0 0.321 0.040 0.453 0.108l5.748 2.924c0.137 0.071 0.293 0.111 0.459 0.111 0.552 0 1-0.448 1-1 0-0.055-0.004-0.109-0.012-0.156l-1.008-6.393c-0.006-0.046-0.010-0.092-0.010-0.139 0-0.271 0.108-0.516 0.282-0.696l4.571-4.578c0.181-0.181 0.292-0.431 0.292-0.707 0-0.497-0.362-0.909-0.842-0.988l-6.394-1.017c-0.303-0.054-0.559-0.245-0.704-0.512l-2.947-5.774c-0.166-0.321-0.502-0.54-0.888-0.54s-0.722 0.219-0.891 0.546l-2.937 5.756c-0.141 0.273-0.405 0.472-0.723 0.526zM15.39 9.145l0.61-1.195 2.737 5.363 1.483 0.236c-0.004-0 0.004 0.001 0.012 0.002l0.012 0.002 4.44 0.706-4.255 4.261 0.232 1.47 0.006 0.037 0.7 4.44-5.367-2.729-5.367 2.73 0.209-1.325 0.73-4.623-4.256-4.261 5.947-0.946 2.127-4.168z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mail",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 7V25H27V7M5 7H27M5 7L16 17.5L27 7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.c5d2a9b01118cb93f17ee59e7a09cf7d.svg";
export { ForwardRef as ReactComponent };